import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Switch, Route, NavLink, useLocation } from "react-router-dom";
import {
  CalendarIcon,
  ChartBarIcon,
  CreditCardIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  TagIcon,
  ShoppingBagIcon,
  BuildingOffice2Icon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import Tab from "../../components/tabs";
import TabVehicals from "../../components/tabs2";
import Favourit from "../../components/Favourites";
import Profile from "../../components/Profile";
import ChangePassword from "../../components/ChangePassword";
import Shiping from "../../components/Shiping/index";
import AddWatchlist from "../../components/Add Watchlist";
import WatchlistActive from "../../components/WatchlistActive";
import Arbitration from "../../components/Arbitration";
import Offices, { OfficeForm, OfficeHours } from "../../components/Offices";
import InspectionUsers, {
  InspectionUserForm,
} from "../../components/InspectionUsers";
import OfficeAppointments, {
  OfficeAppointmentForm,
  AllAppointmentsList,
} from "../../components/OfficeAppointments";
import ProductMain from "../../components/Product View/ProductMain";
import ProductMainBuy from "../../components/Product View buy/ProductMain";
import AuctionFloor from "../Auction";
import BuyNowFloor from "../Buynow";
import CarReport from "../Car Report";
import {
  getDealerAvatarUrl,
  getDealerDisplayName,
  getDealerInitials,
} from "../../utils/dealerIdentity";
import { DashboardHeader, DashboardFooter } from "./DashboardChrome";
import DashboardHome from "./DashboardHome";
import "./dealers-dashboard.css";
import "./style.css";

const DD_TOPBAR_H = 56;

const navigation = [
  { name: "Dashboard", href: "/dealers/dashbord", icon: HomeIcon },
  { name: "Auctions", href: "/dealers/dashbord/auction", icon: TagIcon },
  { name: "Buy now", href: "/dealers/dashbord/buynow", icon: ShoppingBagIcon },
  { name: "My Bids", href: "/dealers/dashbord/mybids", icon: ChartBarIcon },
  { name: "My Vehicles", href: "/dealers/dashbord/myvehicles", icon: UsersIcon },
  { name: "Offices", href: "/dealers/dashbord/offices", icon: BuildingOffice2Icon },
  { name: "Appointments", href: "/dealers/dashbord/appointments", icon: CalendarIcon },
  { name: "Favourites", href: "/dealers/dashbord/favourites", icon: FolderIcon },
  {
    name: "Payments & Shipping",
    href: "/dealers/dashbord/shipping",
    icon: CreditCardIcon,
  },
  { name: "Arbitration", href: "/dealers/dashbord/arbitration", icon: InboxIcon },
];

function Layout({ auth }) {
  const location = useLocation();
  const dealerName = getDealerDisplayName(auth);
  const dealerInitials = getDealerInitials(auth);
  const dealerAvatar = getDealerAvatarUrl(auth);
  const [avatarFailed, setAvatarFailed] = useState(false);
  const showAvatar = Boolean(dealerAvatar) && !avatarFailed;

  useEffect(() => {
    setAvatarFailed(false);
  }, [dealerAvatar]);

  const isProductPage =
    location.pathname === "/dealers/dashbord/product" ||
    location.pathname === "/dealers/dashbord/productbuy" ||
    location.pathname === "/dealers/dashbord/carreport";
  const isFloorPage =
    location.pathname === "/dealers/dashbord/auction" ||
    location.pathname === "/dealers/dashbord/buynow";

  const isActive = (href) => {
    if (href === "/dealers/dashbord/offices") {
      return (
        location.pathname.startsWith(href) &&
        !location.pathname.startsWith("/dealers/dashbord/appointments")
      );
    }
    if (href === "/dealers/dashbord/appointments") {
      return location.pathname === href;
    }
    return location.pathname === href;
  };

  const renderSection = (title, subtitle, children) => (
    <div className="dd-panel">
      <header className="dd-page-head">
        <div className="dd-page-head__mark" aria-hidden="true" />
        <div className="dd-page-head__copy">
          <p className="dd-page-head__eyebrow">AutoTrade Port · Dealers</p>
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </header>
      <div className="dd-panel__body">{children}</div>
    </div>
  );

  const renderFloor = (title, subtitle, children) => (
    <div className="dd-panel dd-panel--floor">
      <header className="dd-page-head">
        <div className="dd-page-head__mark" aria-hidden="true" />
        <div className="dd-page-head__copy">
          <p className="dd-page-head__eyebrow">AutoTrade Port · Dealers</p>
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </header>
      <div className="dd-panel__body dd-panel__body--flush dd-panel__body--floor">
        {children}
      </div>
    </div>
  );

  return (
    <div
      className="dd-shell dd-shell--full"
      style={{ ["--dd-nav-h"]: `${DD_TOPBAR_H}px` }}
    >
      <div className="dd-shell__fx" aria-hidden="true">
        <span className="dd-shell__orb dd-shell__orb--a" />
        <span className="dd-shell__orb dd-shell__orb--b" />
        <span className="dd-shell__grid" />
      </div>

      <DashboardHeader auth={auth} />

      <nav className="dd-mobile-nav" aria-label="Dashboard sections">
        {navigation.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            exact
            className={`dd-mobile-nav__link${
              isActive(item.href) ? " is-active" : ""
            }`}
          >
            {item.name}
          </NavLink>
        ))}
      </nav>

      <div className="dd-shell__body">
        <aside className="dd-rail" aria-label="Dashboard menu">
          <div className="dd-rail__top">
            <div className="dd-rail__user" title={dealerName}>
              <span className="dd-rail__avatar" aria-hidden="true">
                {showAvatar ? (
                  <img
                    src={dealerAvatar}
                    alt=""
                    onError={() => setAvatarFailed(true)}
                  />
                ) : (
                  dealerInitials
                )}
              </span>
              <div className="dd-rail__meta">
                <span className="dd-rail__label">Dealer desk</span>
                <span className="dd-rail__name">{dealerName}</span>
              </div>
            </div>

            <p className="dd-rail__kicker">Workspace</p>
            <nav className="dd-nav">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.href}
                    to={item.href}
                    exact
                    title={item.name}
                    className={`dd-nav-link${
                      isActive(item.href) ? " is-active" : ""
                    }`}
                  >
                    <Icon aria-hidden="true" />
                    <span>{item.name}</span>
                  </NavLink>
                );
              })}
            </nav>
          </div>
          <div className="dd-rail__foot">
            <span className="dd-rail__foot-badge">ATP</span>
            <span className="dd-rail__foot-copy">Trade floor workspace</span>
          </div>
        </aside>

        <main
          className={`dd-stage${
            isProductPage ? " dd-stage--product" : ""
          }${isFloorPage ? " dd-stage--floor" : ""}`}
        >
          <Switch>
            <Route exact path="/dealers/dashbord">
              {renderSection(
                "Dashboard",
                "Overview of bids, stock, and inspection offices.",
                <DashboardHome />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/mybids">
              {renderSection(
                "My bids",
                "Track active, upcoming, won, and lost auction activity.",
                <Tab />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/auction">
              {renderSection(
                "Auctions",
                "Browse live and upcoming lots with filters and sort.",
                <AuctionFloor />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/buynow">
              {renderSection(
                "Buy now",
                "Browse fixed-price stock with filters, sort, and list or grid views.",
                <BuyNowFloor />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/myvehicles">
              {renderSection(
                "My vehicles",
                "Manage stock, auctions, and buy-now listings from one desk.",
                <TabVehicals />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices">
              {renderSection(
                "Offices",
                "Inspection centres used when booking appointments.",
                <Offices />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/appointments">
              {renderSection(
                "Appointments",
                "All bookings across your inspection centres.",
                <AllAppointmentsList />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/new">
              {renderSection(
                "Add office",
                "Create a new inspection centre.",
                <OfficeForm />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/:officeId/hours">
              {renderSection(
                "Office hours",
                "Weekday opening times used for appointment booking.",
                <OfficeHours />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/:officeId/appointments/new">
              {renderSection(
                "Add appointment",
                "Book a vehicle evaluation and inspection for your client.",
                <OfficeAppointmentForm />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/:officeId/appointments">
              {renderSection(
                "Office appointments",
                "Bookings for this inspection centre.",
                <OfficeAppointments />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/:officeId/users/new">
              {renderSection(
                "Add inspection user",
                "Create a login for staff at this inspection centre.",
                <InspectionUserForm />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/:officeId/users/:userId/edit">
              {renderSection(
                "Edit inspection user",
                "Update this inspector’s details and office assignment.",
                <InspectionUserForm />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/:officeId/users">
              {renderSection(
                "Inspection users",
                "Staff accounts for this inspection centre.",
                <InspectionUsers />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/offices/:id/edit">
              {renderSection(
                "Edit office",
                "Update this inspection centre.",
                <OfficeForm />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/profile">
              {renderSection(
                "Profile",
                "Keep dealer contact and account details current.",
                <Profile />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/change-password">
              {renderSection(
                "Change password",
                "Update your dealer desk login credentials.",
                <ChangePassword />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/favourites">
              {renderSection(
                "Favourites",
                "Lots you are watching across buy now and auctions.",
                <Favourit />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/shipping">
              {renderSection(
                "Payments & shipping",
                "Settlement and delivery details for won or purchased stock.",
                <Shiping />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/arbitration">
              {renderSection(
                "Arbitration",
                "Raise and follow trade disputes with supporting media.",
                <Arbitration />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/watchlist">
              {renderSection(
                "Add watchlist",
                "Build a watchlist for vehicles you want to track.",
                <AddWatchlist />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/watchlistActive">
              {renderSection(
                "Watchlist active",
                "Active watchlist items currently on your desk.",
                <WatchlistActive />
              )}
            </Route>
            <Route exact path="/dealers/dashbord/product">
              <div className="dd-panel dd-panel--product">
                <header className="dd-page-head">
                  <div className="dd-page-head__mark" aria-hidden="true" />
                  <div className="dd-page-head__copy">
                    <p className="dd-page-head__eyebrow">AutoTrade Port · Dealers</p>
                    <h1>Auction lot</h1>
                    <p>
                      Gallery, bidding tools, shipping estimate, and vehicle
                      disclosures.
                    </p>
                  </div>
                </header>
                <div className="dd-panel__body dd-panel__body--flush">
                  <ProductMain />
                </div>
              </div>
            </Route>
            <Route exact path="/dealers/dashbord/productbuy">
              <div className="dd-panel dd-panel--product">
                <header className="dd-page-head">
                  <div className="dd-page-head__mark" aria-hidden="true" />
                  <div className="dd-page-head__copy">
                    <p className="dd-page-head__eyebrow">AutoTrade Port · Dealers</p>
                    <h1>Buy now lot</h1>
                    <p>
                      Gallery, purchase action, shipping estimate, and vehicle
                      disclosures.
                    </p>
                  </div>
                </header>
                <div className="dd-panel__body dd-panel__body--flush">
                  <ProductMainBuy />
                </div>
              </div>
            </Route>
            <Route exact path="/dealers/dashbord/carreport">
              <div className="dd-panel dd-panel--product">
                <header className="dd-page-head">
                  <div className="dd-page-head__mark" aria-hidden="true" />
                  <div className="dd-page-head__copy">
                    <p className="dd-page-head__eyebrow">AutoTrade Port · Dealers</p>
                    <h1>Vehicle history report</h1>
                    <p>
                      Inspection score, damage map, and section-by-section
                      findings for this lot.
                    </p>
                  </div>
                </header>
                <div className="dd-panel__body dd-panel__body--flush">
                  <CarReport />
                </div>
              </div>
            </Route>
          </Switch>
        </main>
      </div>

      <DashboardFooter />
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Layout);
